import { IDBPDatabase } from 'idb'

import { IDBSchema } from '../types'

/**
 * CHANGES:
 *
 * - Removed `models`, `fields` & `enums` tables
 */

export default (
  database: IDBPDatabase<IDBSchema>,
  transaction: IDBTransaction,
  next: () => void
) => {
  STUDIO_ENV_DEVELOPMENT && console.log('---Running migration for v10---')

  database.deleteObjectStore('models')
  database.deleteObjectStore('fields')
  database.deleteObjectStore('enums')

  STUDIO_ENV_DEVELOPMENT && console.log('---Migrated to v10---')
  return next()
}
